import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import { ClinicalFormFillupRequest } from "../../../api/ClinicalIntake";
import Fontstyling from "../../../components/common/comman";
import toastFile from "../../../Service/ToastFile";

const SBARFormRequest = () => {
  const user = useSelector((state) => state.userDetails.value);
  const [comment, setComment] = useState("");
  const onSubmit = () => {
    // let payload = {
    //   userid: user?.UD_id,
    //   comment,
    // };
    // console.log({payload})
    ClinicalFormFillupRequest(user?.UD_id, comment).then((res) => {
      if (res?.status === 200 || res?.status === 204) {
        toastFile(res.data, "success");
        setComment("");
      }
      else{
        toastFile(res?.response?.data, "error");
      }
    });
  };
  return (
    <div>
      <div style={Fontstyling.heading}>Request access to SBAR form :</div>
      <div style={Fontstyling.primaryparagraph} className="mt-2 mb-1">Add specific information to require SBAR form with comprehensive claimant analysis</div>
      <Form.Control
        as="textarea"
        placeholder="Leave a information here"
        style={{...Fontstyling.label, minHeight: "300px" }}
        value={comment}
        onChange={(e) => setComment(e.target.value)}
      />
      <div className="d-flex align-items-center justify-content-end">
        <Button
          type="button"
          className="mt-3"
          style={Fontstyling.savebutton}
          disabled={comment.length < 1}
          onClick={() => onSubmit()}
        >
          Submit
        </Button>
      </div>
    </div>
  );
};

export default SBARFormRequest;
